import { r as registerInstance, h } from './index-5faac9d7.js';
import { i as isEmpty_1 } from './isEmpty-51908328.js';
import { g as getData } from './http-0a1631f3.js';
import './_nodeUtil-f95b2b52.js';
import './_commonjsHelpers-11ca3be1.js';
import './utils-6c8f178b.js';
import './currency-7be6806c.js';

const HmcWidget = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.closeModal = () => {
      this.data = null;
      this.rangeTooltipInfo = null;
      this.isOpened = false;
    };
    this.fetchQuestionnaire = (id) => {
      if (!id) {
        return;
      }
      const rest = this.questionnaireUrl.replace(':id', id);
      getData(false, rest).then((res) => {
        if (!isEmpty_1(res)) {
          this.data = res;
        }
      });
    };
    this.fetchSelectorConfig = () => {
      getData(false, this.selectorConfigUrl).then((res) => {
        if (!isEmpty_1(res)) {
          this.selectorConfig = res;
        }
      });
    };
    this.createRangeTooltipInfoMap = (presentations) => presentations.reduce((obj, range) => {
      if (!obj[range.rangeId]) {
        return Object.assign(Object.assign({}, obj), { [range.rangeId]: range });
      }
      return Object.assign({}, obj);
    }, {});
    this.fetchRangeTooltipInfo = (rangeIds) => {
      if (!rangeIds) {
        return;
      }
      if (!isEmpty_1(this.rangeTooltipInfo)
        && rangeIds.every((id) => Object.keys(this.rangeTooltipInfo).includes(id))) {
        return this.rangeTooltipInfo;
      }
      const rest = this.rangeTooltipUrl.replace(':ids', rangeIds.join());
      getData(false, rest).then((res) => {
        if (!isEmpty_1(res) && !isEmpty_1(res.presentations)) {
          this.rangeTooltipInfo = this.createRangeTooltipInfoMap(res.presentations);
        }
      });
    };
    this.categoryId = undefined;
    this.questionnaireUrl = undefined;
    this.rangeTooltipUrl = undefined;
    this.selectorConfigUrl = undefined;
    this.isPBS = false;
    this.data = undefined;
    this.rangeTooltipInfo = undefined;
    this.selectorConfig = undefined;
    this.isOpened = false;
  }
  handleRangesDisplay(e) {
    const rangesIds = e.detail;
    this.fetchRangeTooltipInfo(rangesIds);
  }
  handleCloseDialog() {
    this.closeModal();
  }
  handleOpenProductSelector() {
    this.closeModal();
  }
  componentWillLoad() {
    this.fetchQuestionnaire(this.categoryId);
    this.fetchSelectorConfig();
    this.isOpened = true;
  }
  render() {
    return (h("pes-hmc-modal", { data: this.data, isPBS: this.isPBS, isOpened: this.isOpened, rangeTooltipInfo: this.rangeTooltipInfo, selectorConfig: this.selectorConfig }));
  }
};

export { HmcWidget as pes_hmc_widget };
